"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GitHubAppInstallQueryField = void 0;
// Query param the GitHub App install Setup URL callback appends to the frontend redirect so the
// connect-provider slide-over can show the install outcome. Mirrors the connected_payroll /
// connected_version_control conventions used by the other connect flows.
var GitHubAppInstallQueryField;
(function (GitHubAppInstallQueryField) {
    GitHubAppInstallQueryField["CONNECTED_STATUS"] = "connected_github_app";
})(GitHubAppInstallQueryField || (exports.GitHubAppInstallQueryField = GitHubAppInstallQueryField = {}));
